<template>
  <Navigation />
  <div id="fun-area" :class="{ showTop:langShow == 'zh'}">
    <div class="editBox" ref="editBox">
      <router-view></router-view>
    </div>
  </div>
  <Secure />
  <Operation />
  <Explain />
  <Reviews />
  <AllTotals />
  <Purchase v-if="$store.state.isShowPur" />
  <!-- <Footer /> -->
  <el-backtop :bottom="100">
    <span data-toggle="backToTop" style="z-index:10;" class="backToTop show">
      <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#000" fill-opacity="0.7" d="M.5.5h39v39H.5z" />
        <path d="M13 19l7-7 7 7M20 13v16" stroke="#fff" stroke-width="3" stroke-linecap="square" />
      </svg>
    </span>
  </el-backtop>
</template>
<script>
  import Navigation from './components/Navigation.vue'
  import Secure from './components/Secure.vue'
  import Operation from './components/Operation.vue'
  import Purchase from './components/common/purchase.vue'
  // import Score from './components/Score'
  import Explain from './components/Explain.vue'
  import Reviews from './components/Reviews'
  import AllTotals from './components/AllTotals'
  // import FunList from './components/FunList.vue'
  import Footer from './components/footer.vue'

  export default {
    name: 'App',
    data() {
      return {
        radio: '1',
        langShow: '',
      }
    },
    computed: {
      getAppStore() {
        return this.$store.state.appState
      }
    },
    methods: {
      getPdfToken() {
        // //console.log("wahahah");
        this.$http
          .postGetToken('/app/getToken')
          .then((responst) => {
            this.$cookies.set('pdfToken', responst.data)
            this.$store.commit('changePdfToken', responst.data)
          })
          .catch(() => {
            var timer = setInterval(() => {
              clearImmediate(timer)
              this.getPdfToken()
            }, 3000)
          })
      },
      scrollDs() {
        if (!document.querySelector('.backToTop')) return
        if (document.documentElement.scrollTop >= 500) {
          document.querySelector('.backToTop').classList.add('active')
          document.querySelector('.backToTop').classList.remove('show')
        } else {
          document.querySelector('.backToTop').classList.add('show')
          document.querySelector('.backToTop').classList.remove('active')
        }
      },
      backToTop() {
        // //console.log("111");
        document.documentElement.scrollTop = 0
      },
      beforeunloadFn(e) {
        const _this = this
        e = e || window.event
        // //console.log("beforeunloadFn:", this.$store.state.appState, sessionStorage.getItem('abandon'));
        //上传的时候和转化的时候刷新要浏览器拦截，转化的时候弹窗出现的话浏览器就不拦截
        // debugger
        // if ((this.$store.state.appState == 'operate' || (this.$store.state.appState == 'converting' && sessionStorage.getItem('abandon') == 'false') || this.$store.state.isDown == 2) && e) {
        //   //console.log("lalala:", _this);
        //   //console.log(_this);
        //   if (e) {
        //     e.returnValue = '关闭提示';
        //   }
        //   return '关闭提示';
        // }
        // //console.log("------------------------------------------------------------------------");
        // if (this.$store.state.appState == 'converted' && this.$store.state.isDown == 2) {

        // }
        // // 这个事件只有在鼠标真正和浏览器有了交互，再刷新或者关闭时才会触发, 浏览器事件会弹框确认用户是否要离开页面
      }
    },
    watch: {
      $route: {
        handler(to) {
          if (this.$route.fullPath.indexOf('convert') > 0) {
            document.querySelectorAll(".convert-tool")[0].style.color = "#4260FF"
            document.querySelectorAll(".merge-tool")[0].style.color = "#3D454D"
            document.querySelectorAll(".all-tool")[0].style.color = "#3D454D"
          } else if (this.$route.fullPath.indexOf('pdf-combiner') > 0) {
            document.querySelectorAll(".merge-tool")[0].style.color = "#4260FF"
            document.querySelectorAll(".convert-tool")[0].style.color = "#3D454D"
            document.querySelectorAll(".all-tool")[0].style.color = "#3D454D"
          } else {
            document.querySelectorAll(".merge-tool")[0].style.color = "#3D454D"
            document.querySelectorAll(".convert-tool")[0].style.color = "#3D454D"
            document.querySelectorAll(".all-tool")[0].style.color = "#4260FF"
          }
          // //console.log("app路由变了");
        },
        deep: true
      },
    },
    components: {
      Navigation,
      Explain,
      // FunList,
      // Score,
      Footer,
      Operation,
      Secure,
      Reviews,
      AllTotals,
      Purchase
    },
    mounted() {
      console.log("=================================测试版本======================================");
      // const url = require("../src/assets/error.svg")
      // this.$confirm("<img src = " + url + " style='vertical-align: middle;'/><span class='alertSpan'>" + this.$t(`message.commonTip.alertTip[6].poptext`) + "</span>", {
      //   confirmButtonText: this.$t(`message.commonTip.alertTip[6].confirmButtonText`),
      //   cancelButtonClass: 'noneBtn',
      //   dangerouslyUseHTMLString: true,
      //   closeOnClickModal: false
      // }).then(() => {
      //   window.location.reload()
      // }).catch(() => {
      // });
      window.addEventListener('scroll', this.scrollDs, true)
      window.addEventListener('beforeunload', (e) => this.beforeunloadFn(e))
      // //console.log('----------:', this.$store.state.appState);
      this.$cookies.isKey('pdfToken') ? this.$store.commit('changePdfToken', this.$cookies.get('pdfToken')) : this.getPdfToken()
      // let imgs = 'https://pdnob.passfab.com/images/pdnob1-4/icon-conveting.svg'
      // let image = new Image()
      // image.src = imgs
      // var element = document.createElement('script')
      // element.src = 'https://www.tenorshare.com/rn-ui/js/rn-ui-passfab-0.0.3.min.js'
      // document.body.appendChild(element)
      let myDate = new Date()
      // //console.log("-----", myDate.toLocaleString().substring(0, 9));
      if (localStorage.getItem("user_views") && localStorage.getItem("user_views") != myDate.toLocaleString().substring(0, 9)) {
        this.$gtag.event("user_views", {
          event_category: "pageviews",
          event_label: "old",
        });
        localStorage.setItem("user_views", myDate.toLocaleString().substring(0, 9))
      } else if (!localStorage.getItem("user_views")) {
        localStorage.setItem("user_views", myDate.toLocaleString().substring(0, 9))
        this.$gtag.event("user_views", {
          event_category: "pageviews",
          event_label: "new",
        });
      }
      var b = document.getElementsByClassName('footer')[0]
      b.style.display = 'block'
    },
    created() {
      this.$nextTick(() => {
        const local = document.getElementsByTagName('html')[0].attributes['lang'].nodeValue //window.location.host.split(".")[2];
        // //console.log("local:", local);
        this.langShow = local
        this.$i18n.locale = local
        this.$store.commit('checkLocal', this.langShow)
        this.$cookies.set('checkLocal', this.langShow)
      })
    },
    unmounted() {
      window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    }
  }
</script>
<style lang="scss" scope>
  img {
    -webkit-user-drag: none;
  }

  .alertSpan {
    margin-left: 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    color: rgba(29, 29, 31, 0.7);
  }

  .cancleBtn {
    display: none !important;
  }

  #app {
    /* font-family: Avenir, Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    /* font-family: 'Be Vietnam Pro', sans-serif; */
    color: #001637;

    h2 {
      margin: 0;
    }

    ul {
      margin: 0;
      padding: 0;
    }
  }

  .show {
    display: none !important;
  }

  .active {
    display: block !important;
  }

  .el-backtop {
    background-color: rgb(0, 0, 0, 0) !important;
    box-shadow: none !important;
    bottom: 45px !important;
    right: 12px !important;
    z-index: 10 !important;
  }

  .footer a:hover {
    color: #fff !important;
    text-decoration: underline;
  }

  p {
    margin-bottom: 0;
  }

  li {
    list-style-type: none;
  }

  .flexible {
    display: flex;
  }

  .flex-justify-between {
    justify-content: space-between;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  #fun-area {
    padding-top: 64px;
    /* // padding-bottom: 80px; */
    background: url('data:image/svg+xml;base64,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');
    background-size: cover;
    height: 568px;

    .editBox {
      max-width: 1224px;
      margin: 72px auto auto auto;
      position: relative;
      height: 548px;
      display: flex;
      box-shadow: 0px 10px 16px rgb(84 82 246 / 8%);
      border-radius: 16px
    }
  }

  #fun-area.showTop {
    padding-top: 100px;
  }

  .fun-area-wrap {
    width: 100%;

    .el-upload,
    .upload-area,
    .grid-content {
      height: 100%;
    }

    .el-upload,
    .el-upload-dragger {
      /* width: 100%; */
      width: 1176px;
      height: 500px;
    }

    .upload-area {
      .el-upload {
        .el-upload-dragger {
          height: 100%;
          /* padding: 24px; */
          padding-top: 40px;
          border: 2px dashed #eaeaea;

          &:hover {
            border: 2px dashed #cccbfc;
          }

          &:active {
            border: 2px dashed #cccbfc;
          }

          &:focus {
            border: 2px dashed #5452f6;
            background-color: red;
          }
        }
      }
    }
  }
</style>